import React from "react";
import { ShieldCheck, Truck, BadgeCheck, Sparkles } from "lucide-react";

const items = [
    { Icon: ShieldCheck, title: "Compra segura", desc: "Pagamento protegido nas plataformas oficiais" },
    { Icon: Truck, title: "Entrega garantida", desc: "Envio feito pela plataforma de compra" },
    { Icon: BadgeCheck, title: "Produtos selecionados", desc: "Curadoria oficial da marca" },
    { Icon: Sparkles, title: "Qualidade premium", desc: "Materiais com acabamento superior" },
];

const TrustBlock = ({ className = "" }) => (
    <section
        data-testid="trust-block"
        className={`bg-white border-y border-brand-border ${className}`}
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
                {items.map(({ Icon, title, desc }) => (
                    <div key={title} className="flex flex-col items-center text-center space-y-3" data-testid={`trust-item-${title}`}>
                        <div className="w-12 h-12 rounded-full border border-brand-gold/30 bg-brand-gold/5 flex items-center justify-center">
                            <Icon className="w-5 h-5 text-brand-gold" strokeWidth={1.75} />
                        </div>
                        <h4 className="font-heading text-xs sm:text-sm font-bold uppercase tracking-[0.15em] text-brand-ink">
                            {title}
                        </h4>
                        <p className="text-xs text-brand-inkSoft max-w-[180px] leading-relaxed">{desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default TrustBlock;
